(function () {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('retrievePUKCtrl', ['$scope', '$http', 'uteEndpoint', 'commonService', '$rootScope', '$state', '$stateParams', 'dtmService', 'dtmServiceConstants', function ($scope, $http, uteEndpoint, commonService, $rootScope, $state, $stateParams, dtmService, dtmServiceConstants) {
    console.log('retrievePUKCtrl :: Start ');
    $scope.ban = $stateParams.accountNumber;
    $scope.userCTN = $stateParams.ctn;
    $scope.showError = false;


    $scope.init = function () {
      $scope.accountDetails = commonService.accountDetails;
      // var formattedStateParams =  "("+ $stateParams.ctn.substring(0,3) +")"+$stateParams.ctn.substring(3,6)+"-"+$stateParams.ctn.substring(6,10);
      //$scope.selectedAccount = $stateParams.accountNumber;

      //FUSS-1815 - fix for CTN list empty upon language toggling
      if($stateParams.accountNumber && $stateParams.ctn){
        $scope.selectedAccount = $stateParams.accountNumber;
        $scope.ban = $stateParams.accountNumber;
        $scope.userCTN = $stateParams.ctn;
      }else if((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) || (!$stateParams.ctn && !$rootScope.userInfo.selectedSubscriberNo)){
        $state.go('myAccount.overview');
      }else {
        if ($rootScope.userInfo.selectedAccountNumber) {
          $scope.selectedAccount = $rootScope.userInfo.selectedAccountNumber;
          $scope.ban = $rootScope.userInfo.selectedAccountNumber;
        }
        if($rootScope.userInfo.selectedSubscriberNo) {
          $scope.userCTN = $rootScope.userInfo.selectedSubscriberNo;
        }
      }

      var ctnList = [];
      var arrayLength = $scope.accountDetails.length;
      var formattedCTN = '';

      for (var i = 0; i < arrayLength; i++) {
        if ($scope.accountDetails[i].accountNumber == $scope.selectedAccount) {
          var innerLength = $scope.accountDetails[i].subscriberServices.length;
          for (var j = 0; j < innerLength; j++) {
            $.each($scope.accountDetails[i].subscriberServices[j], function (key, value) {
              if (key == 'wireless') {
                // formattedCTN = "("+ value.subscriberNo.substring(0,3) +")"+value.subscriberNo.substring(3,6)+"-"+value.subscriberNo.substring(6,10);
                //console.log(formattedCTN);
                ctnList.push(value.subscriberNo);
              }
            });
          }
        }
      }
      $scope.ctnList = ctnList;
      console.log($scope.ctnList);
    };


    $scope.retrievePUKCode = function () {
      var customerSelectedCTN = $scope.userCTN;
      console.log("ctn selected" + customerSelectedCTN);
      $http({
        method: 'POST',
        url: uteEndpoint('v1/puk/pukcode'),
        data: {
          accountNumber: $scope.ban,
          customer_ctn: customerSelectedCTN
        }
      }).success(function (data) {
        $scope.showPUKCode = true;
        $scope.pukCode = data;
        dtmService.complete(dtmServiceConstants.dtmRules.receivePUKCode.name);

      }).error(function (data) {
        dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.receivePUKCode.name, [dtmServiceConstants.dtmRules.receivePUKCode.defaultServerError], 'SS');
        $scope.showError = true;
      });
    };

    $scope.backToAccount = function () {
      $state.go("myAccount.overview");
    };

    // FUSS-962 : Clicking on cancel button should go to previous page - START
    $scope.cancel = function () {
      _.each($scope.accountDetails, function (accountDetail) {
        if ($scope.ban === accountDetail.accountNumber) {
          if (accountDetail.LOB && accountDetail.LOB.toUpperCase() === 'WL') {
            $state.go('myAccount.wireless', {'accountNumber': $scope.ban, 'subscriberNo': $scope.userCTN});
          } else if (accountDetail.LOB && accountDetail.LOB.toUpperCase() === 'WLPP') {
            $state.go('myAccount.prepaidWLDashboard', {'accountNumber': $scope.ban, 'subscriberNo': $scope.userCTN});
          } else {

          }
        }
      });
    };
    // FUSS-962 : Clicking on cancel button should go to previous page - END

    $scope.dropDownChanged = function () {
      console.log('drop -down -changed');
      $scope.showPUKCode = false;
    };

    $scope.showDetails = false;
    $scope.clickButton = false;
    $scope.showFullDetails = function () {
      $scope.showDetails = true;
      $scope.clickButton = true;
    };
    $scope.hideFullDetails = function () {
      $scope.showDetails = false;
      $scope.clickButton = false;
    }
  }]);

})();


